import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTikTokLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 17,
	fill: "none",
	viewBox: "0 0 16 17",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#FF004F",
			d: "M11.45 6a6.2 6.2 0 0 0 3.65 1.17V4.54q-.38 0-.77-.08v2.07a6.2 6.2 0 0 1-3.65-1.17v5.36a4.85 4.85 0 0 1-7.53 4.04 4.85 4.85 0 0 0 8.3-3.4zm.95-2.65a3.7 3.7 0 0 1-.95-2.15V.86h-.73c.19 1.05.81 1.94 1.68 2.49M4.84 12.7a2.22 2.22 0 0 1 2.43-3.46v-2.7a5 5 0 0 0-.76-.04v2.1a2.2 2.2 0 0 0-2.9 2.12c0 .86.5 1.61 1.23 1.98"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#000",
			d: "M10.68 5.36a6.2 6.2 0 0 0 3.65 1.17V4.46a3.7 3.7 0 0 1-1.93-1.11A3.7 3.7 0 0 1 10.72.86h-1.9v10.5a2.22 2.22 0 0 1-3.98 1.34A2.22 2.22 0 0 1 6.5 8.6V6.5a4.85 4.85 0 0 0-3.36 8.26 4.85 4.85 0 0 0 7.54-4.04z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#00F2EA",
			d: "M14.34 4.46V3.9q-1.05 0-1.94-.55c.51.56 1.19.95 1.94 1.11M10.72.86l-.04-.3V.22H8.05v10.5a2.22 2.22 0 0 1-3.21 1.98 2.2 2.2 0 0 0 3.98-1.34V.86zM6.51 6.5v-.6a4.85 4.85 0 0 0-3.36 8.85A4.85 4.85 0 0 1 6.5 6.51"
		})
	]
});
export { SvgTikTokLogo as ReactComponent };
